import React, { useEffect, useState } from "react"
import { getAllRegistries } from "../../utils/ApiRequests"
import RegistryCard from "./RegistryCard"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import "./styles.scss"
import FullLoader from "../../components/Loaders/FullLoader"
import Navbar from "../../components/Navbar/Navbar"

export default function FindRegistry() {
  const [loading, setLoading] = useState(true)
  const [registries, setRegistries] = useState([])
  const [evolvingRegisteries, setEvolvingReistries] = useState([])
  const [searchItem, setSearchItem] = useState()

  useEffect(() => {
    getAllRegistries()
      .then(res => {
        setRegistries(res.data?.data)
        setLoading(false)
      })
      .catch(err => {
        console.log(err.response)
        setLoading(false)
      })
  }, [])

  const handleFind = () => {
    const filteredRegistry = evolvingRegisteries.filter(registry => {
      return registry?.slug === searchItem?.slug
    })
    setEvolvingReistries(filteredRegistry)
  }

  const items = registries?.map(registry => {
    return {
      slug: registry.slug,
      name: registry.name
    }
  })

  if (loading) {
    return <FullLoader />
  }

  const handleOnSelect = item => {
    // the item selected
    setSearchItem(item)
  }

  const handleOnFocus = () => {
    setSearchItem()
    setEvolvingReistries(registries)
  }

  const handleOnClear = () => {
    setSearchItem()
    setEvolvingReistries(registries)
  }

  return (
    <div>
      <Navbar />
      <div className="global-container py-20">
        <div className="header my-10 text-center">
          <h1>Find an event Registry or Website</h1>
        </div>

        <div className="search-container find__registry-search-wrapper border rounded-md flex flex-wrap p-10">
          <div className="mobiles:w-full w-2/3 ">
            <ReactSearchAutocomplete
              items={items}
              onSelect={handleOnSelect}
              onFocus={handleOnFocus}
              onClear={handleOnClear}
              autoFocus
            />
          </div>

          <button
            className=" px-6 mobiles:w-full mobiles:mt-4 py-3 m-auto rounded-md text-center center text-white bg-sbg-light-green font-medium text-xs focus:outline-none"
            onClick={() => {
              handleFind()
            }}
          >
            Find
          </button>
        </div>

        <section className="my-10">
          <div className="my-5 text-center text-gray-400">
            We found {evolvingRegisteries.length} event registr
            {`${evolvingRegisteries.length > 1 ? "ies" : "y"}`}
          </div>
          {/* <div className="listings">{dynamicSearch()}</div> */}
          <div className="flex flex-wrap">
            {evolvingRegisteries
              .slice()
              .reverse()
              .map(registry => {
                return (
                  <RegistryCard
                    header_image={registry.header_image}
                    registry_name={registry.name}
                    start_date={registry.start_date}
                    registry_slug={registry.slug}
                  />
                )
              })}
            {/* {handleSearch()} */}
          </div>
        </section>
      </div>
    </div>
  )
}
